import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import UnAurthorization from "../../screens/UnAuthorizePage/UnAurthorization";
import { GetNavbarMenu } from "../../Services/NavBarMenuService";
import { getDataLocal } from "../../Helper/localStoreFunction";
import { LocalStoreType } from "../../constants/local-type";
const withPerMission =
  (Component: any) =>
  ({ ...props }) => {
    const [isAuthorize, setIsAuthorizeo] = useState(false);
    const [onLoading, setOnLoading] = useState(true);
    const history = useHistory();
    const location = useLocation();
    const isAdmin =getDataLocal(LocalStoreType.isAdmin) === "true"
    const empData = JSON.parse(getDataLocal(LocalStoreType.userData)??{});
    const query = new URLSearchParams(useLocation()?.search);

    useEffect(() => {
      const fetchNav = async () => {
        const menus = await GetNavbarMenu(empData?.employeeData?.Email);
        const _query = query.get("name") || "";

        let _isAuthorize: boolean = isAuthorize;
        menus.forEach((menu,idx)=>{
         
          if (
            menu?.Url?.toLowerCase() === location.pathname?.toLowerCase() ||
            menu?.Url?.toLowerCase() === `/${_query?.toLowerCase()}` ||
            location?.pathname
              ?.toLowerCase()
              .includes(menu?.Url?.toLowerCase()) || isAdmin
          ) {
            _isAuthorize = true;
          }
        })
     
        setOnLoading(false);
        setIsAuthorizeo(_isAuthorize);
      };
      fetchNav();
    }, []);

    return onLoading ? (
      <div />
    ) : isAuthorize ? (
      <Component {...props} />
    ) : (
      <UnAurthorization />
    );
  };
export default withPerMission;
